module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "about"
  }, [(_vm.showWhatModal) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.showWhatModal = false
      }
    }
  }, [_c('h3', {
    slot: "header"
  }, [_vm._v("What is this site?")]), _vm._v(" "), _c('p', {
    slot: "body"
  }, [_vm._v("\n      Uniqitty /uni'kitty/ is a real-time cat name storage app. "), _c('br'), _c('br'), _vm._v("\n      Some cat owners think of some great names for their cats. I felt like it'd be interesting to showcase these and learn some Vue.js at the same time."), _c('br'), _c('br'), _vm._v("\n      If you enjoy Uniqitty - consider "), _c('a', {
    attrs: {
      "href": "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=FWTPPZ352LBMC"
    }
  }, [_vm._v("donating")]), _vm._v(" to give more functionality!\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.showHowModal) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.showHowModal = false
      }
    }
  }, [_c('h3', {
    slot: "header"
  }, [_vm._v("How do I use Uniqitty?")]), _vm._v(" "), _c('p', {
    slot: "body"
  }, [_vm._v("Just add your cats name in the box below!"), _c('br'), _vm._v("If you have more than one, feel free to add that one too."), _c('br'), _c('br'), _c('small', [_vm._v("Try not to spam or fill it with junk..")])])]) : _vm._e(), _vm._v(" "), (_vm.showWhoModal) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.showWhoModal = false
      }
    }
  }, [_c('h3', {
    slot: "header"
  }, [_vm._v("Who made this?")]), _vm._v(" "), _c('p', {
    slot: "body"
  }, [_c('a', {
    attrs: {
      "href": "http://www.chrisgregori.co.uk"
    }
  }, [_vm._v("Chris Gregori")]), _vm._v(" | "), _c('a', {
    attrs: {
      "href": "https://twitter.com/_ChrisGreg"
    }
  }, [_vm._v("@_ChrisGreg")]), _c('br'), _c('br'), _vm._v("I am a Software Engineer who's enjoys making silly little apps."), _c('br'), _c('small', [_vm._v("Donate or follow me on various networks if you'd like to keep up with my projects")])]), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.showWhatModal = true
      }
    }
  }, [_vm._v("What?")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showHowModal = true
      }
    }
  }, [_vm._v("How?")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showWhoModal = true
      }
    }
  }, [_vm._v("Who?")])]), _vm._v(" "), _c('h3', {
    staticClass: "online"
  }, [_vm._v("Currently "), _c('span', {
    staticClass: "cool-cats"
  }, [_vm._v(_vm._s(_vm.numberOfUsers) + " cool " + _vm._s(_vm.peopleText))]), _vm._v(" online looking at cool cats.")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21cfaca6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/furniture/About.vue
// module id = 125
// module chunks = 2